const VALUES = {
    filter_range_start: 0,
    filter_range_max: 1000,
}
export default VALUES;